import React from 'react';
import { Typography } from '@mui/material';

const TimeDisplay = ({ 
  currentTime, 
  duration, 
  formatTimepoint, 
  layout 
}) => {
  // Always visible, but can be compressed

  return (
    <Typography 
      variant="body2" 
      sx={{ 
        minWidth: layout.timeDisplayWidth, 
        maxWidth: layout.timeDisplayWidth + 20, // Allow slight expansion
        fontSize: layout.name === 'verySmall' ? '0.65rem' : layout.name === 'small' ? '0.7rem' : '0.8rem',
        flexShrink: 2, // Can shrink more than other elements
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}
    >
      {formatTimepoint(currentTime)} / {formatTimepoint(duration)}
    </Typography>
  );
};

export default TimeDisplay;
